// INVOICE POS LIST
export const INVOICE_POS_LIST = "INVOICE_POS_LIST";
export const INVOICE_POS_LIST_SUCCESS = "INVOICE_POS_LIST_SUCCESS";
export const INVOICE_POS_LIST_FAIL = "INVOICE_POS_LIST_FAIL";
export const INVOICE_POS_LIST_RESET = "INVOICE_POS_LIST_RESET";
export const INVOICE_POS_LIST_COLUMN = "INVOICE_POS_LIST_COLUMN";
export const INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN =
  "INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN";
export const INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN =
  "INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN";
export const INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN =
  "INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN";

// PHASE INVOICE POS LIST
export const PHASE_INVOICE_POS_LIST = "PHASE_INVOICE_POS_LIST";
export const PHASE_INVOICE_POS_LIST_SUCCESS = "PHASE_INVOICE_POS_LIST_SUCCESS";
export const PHASE_INVOICE_POS_LIST_FAIL = "PHASE_INVOICE_POS_LIST_FAIL";
export const PHASE_INVOICE_POS_LIST_RESET = "PHASE_INVOICE_POS_LIST_RESET";
export const PHASE_INVOICE_POS_LIST_COLUMN = "PHASE_INVOICE_POS_LIST_COLUMN";

// INVOICE LIST CREATE
export const INVOICE_POS_CREATE = "INVOICE_POS_CREATE";
export const INVOICE_POS_CREATE_SUCCESS = "INVOICE_POS_CREATE_SUCCESS";
export const INVOICE_POS_CREATE_FAIL = "INVOICE_POS_CREATE_FAIL";
export const INVOICE_POS_CREATE_RESET = "INVOICE_POS_CREATE_RESET";

// INVOICE LIST EDIT
export const INVOICE_POS_EDIT = "INVOICE_POS_EDIT";
export const INVOICE_POS_EDIT_SUCCESS = "INVOICE_POS_EDIT_SUCCESS";
export const INVOICE_POS_EDIT_FAIL = "INVOICE_POS_EDIT_FAIL";
export const INVOICE_POS_EDIT_RESET = "INVOICE_POS_EDIT_RESET";

// INVOICE POS DETAIL
export const INVOICE_POS_DETAIL = "INVOICE_POS_DETAIL";
export const INVOICE_POS_DETAIL_SUCCESS = "INVOICE_POS_DETAIL_SUCCESS";
export const INVOICE_POS_DETAIL_FAIL = "INVOICE_POS_DETAIL_FAIL";
export const INVOICE_POS_DETAIL_RESET = "INVOICE_POS_DETAIL_RESET";

// PHASE_INVOICE_POS_DETAIL
export const PHASE_INVOICE_POS_DETAIL = "PHASE_INVOICE_POS_DETAIL";
export const PHASE_INVOICE_POS_DETAIL_SUCCESS =
  "PHASE_INVOICE_POS_DETAIL_SUCCESS";
export const PHASE_INVOICE_POS_DETAIL_FAIL = "PHASE_INVOICE_POS_DETAIL_FAIL";
export const PHASE_INVOICE_POS_DETAIL_RESET = "PHASE_INVOICE_POS_DETAIL_RESET";

// LOAD_CONFIG_INVOICE_POS_FIELD
export const LOAD_CONFIG_INVOICE_POS_FIELD = "LOAD_CONFIG_INVOICE_POS_FIELD";
export const LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS =
  "LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS";
export const LOAD_CONFIG_INVOICE_POS_FIELD_FAIL =
  "LOAD_CONFIG_INVOICE_POS_FIELD_FAIL";
export const LOAD_CONFIG_INVOICE_POS_FIELD_RESET =
  "LOAD_CONFIG_INVOICE_POS_FIELD_RESET";

// GET_ENTERPRISE_POS_BY_TAX_CODE
export const GET_ENTERPRISE_POS_BY_TAX_CODE = "GET_ENTERPRISE_POS_BY_TAX_CODE";
export const GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS =
  "GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS";
export const GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL =
  "GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL";
export const GET_ENTERPRISE_POS_BY_TAX_CODE_RESET =
  "GET_ENTERPRISE_POS_BY_TAX_CODE_RESET";

// RELEASE_INVOICE_POS
export const RELEASE_INVOICE_POS = "RELEASE_INVOICE_POS";
export const RELEASE_INVOICE_POS_SUCCESS = "RELEASE_INVOICE_POS_SUCCESS";
export const RELEASE_INVOICE_POS_FAIL = "RELEASE_INVOICE_POS_FAIL";
export const RESET_RELEASE_INVOICE_POS = "RESET_RELEASE_INVOICE_POS";

// REPLACE_INVOICE_POS
export const REPLACE_INVOICE_POS = "REPLACE_INVOICE_POS";
export const REPLACE_INVOICE_POS_SUCCESS = "REPLACE_INVOICE_POS_SUCCESS";
export const REPLACE_INVOICE_POS_FAIL = "REPLACE_INVOICE_POS_FAIL";
export const RESET_REPLACE_INVOICE_POS = "RESET_REPLACE_INVOICE_POS";

// ADJUST_INVOICE_POS
export const ADJUST_INVOICE_POS = "ADJUST_INVOICE_POS";
export const ADJUST_INVOICE_POS_SUCCESS = "ADJUST_INVOICE_POS_SUCCESS";
export const ADJUST_INVOICE_POS_FAIL = "ADJUST_INVOICE_POS_FAIL";
export const RESET_ADJUST_INVOICE_POS = "RESET_ADJUST_INVOICE_POS";

// DOWNLOAD_XML
export const DOWNLOAD_XML_INVOICE_POS = "DOWNLOAD_XML_INVOICE_POS";
export const DOWNLOAD_XML_INVOICE_POS_SUCCESS =
  "DOWNLOAD_XML_INVOICE_POS_SUCCESS";
export const DOWNLOAD_XML_INVOICE_POS_FAIL = "DOWNLOAD_XML_INVOICE_POS_FAIL";
export const RESET_DOWNLOAD_XML_INVOICE_POS = "RESET_DOWNLOAD_XML_INVOICE_POS";
//TRANSFER_USB_INVOICE_POS
export const TRANSFER_USB_INVOICE_POS = "TRANSFER_USB_INVOICE_POS";
export const TRANSFER_USB_INVOICE_POS_SUCCESS =
  "TRANSFER_USB_INVOICE_POS_SUCCESS";
export const TRANSFER_USB_INVOICE_POS_FAIL = "TRANSFER_USB_INVOICE_POS_FAIL";
export const RESET_TRANSFER_USB_INVOICE_POS = "RESET_TRANSFER_USB_INVOICE_POS";
//GENERATE_NUMBER_INVOICE_POS
export const GENERATE_NUMBER_INVOICE_POS = "GENERATE_NUMBER_INVOICE_POS";
export const GENERATE_NUMBER_INVOICE_POS_SUCCESS =
  "GENERATE_NUMBER_INVOICE_POS_SUCCESS";
export const GENERATE_NUMBER_INVOICE_POS_FAIL =
  "GENERATE_NUMBER_INVOICE_POS_FAIL";
export const RESET_GENERATE_NUMBER_INVOICE_POS =
  "RESET_GENERATE_NUMBER_INVOICE_POS";

// PREVIEW_PDF_INVOICE_POS
export const PREVIEW_PDF_INVOICE_POS = "PREVIEW_PDF_INVOICE_POS";
export const PREVIEW_PDF_INVOICE_POS_SUCCESS =
  "PREVIEW_PDF_INVOICE_POS_SUCCESS";
export const PREVIEW_PDF_INVOICE_POS_FAIL = "PREVIEW_PDF_INVOICE_POS_FAIL";
export const RESET_PREVIEW_PDF_INVOICE_POS = "RESET_PREVIEW_PDF_INVOICE_POS";

// DELETE_INVOICE_POS
export const DELETE_INVOICE_POS = "DELETE_INVOICE_POS";
export const DELETE_INVOICE_POS_SUCCESS = "DELETE_INVOICE_POS_SUCCESS";
export const DELETE_INVOICE_POS_FAIL = "DELETE_INVOICE_POS_FAIL";
export const RESET_DELETE_INVOICE_POS = "RESET_DELETE_INVOICE_POS";

// Cancel_INVOICE_POS
export const CANCEL_INVOICE_POS = "CANCEL_INVOICE_POS";
export const CANCEL_INVOICE_POS_SUCCESS = "CANCEL_INVOICE_POS_SUCCESS";
export const CANCEL_INVOICE_POS_FAIL = "CANCEL_INVOICE_POS_FAIL";
export const RESET_CANCEL_INVOICE_POS = "RESET_CANCEL_INVOICE_POS";

// CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS
export const CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS =
  "CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS";
export const CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS =
  "CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS";
export const CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL =
  "CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL";
export const RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS =
  "RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS";

// Clone Envoice
export const CLONE_ENVOICE_POS = "CLONE_ENVOICE_POS";
export const CLONE_ENVOICE_POS_SUCCESS = "CLONE_ENVOICE_POS_SUCCESS";
export const CLONE_ENVOICE_POS_FAIL = "CLONE_ENVOICE_POS_FAIL";
export const RESET_CLONE_ENVOICE_POS = "RESET_CLONE_ENVOICE_POS";

// SEND_MAIL_INVOICE
export const SEND_MAIL_INVOICE_POS = "SEND_MAIL_INVOICE_POS";
export const SEND_MAIL_INVOICE_POS_SUCCESS = "SEND_MAIL_INVOICE_POS_SUCCESS";
export const SEND_MAIL_INVOICE_POS_FAIL = "SEND_MAIL_INVOICE_POS_FAIL";
export const RESET_SEND_MAIL_INVOICE_POS = "RESET_SEND_MAIL_INVOICE_POS";

// ATTACK_FILE_INVOICE_UPLOAD
export const ATTACK_FILE_INVOICE_POS_UPLOAD = "ATTACK_FILE_INVOICE_POS_UPLOAD";
export const ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS =
  "ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS";
export const ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL =
  "ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL";
export const ATTACK_FILE_INVOICE_POS_UPLOAD_RESET =
  "ATTACK_FILE_INVOICE_POS_UPLOAD_RESET";

// GET_INVOICE_REPORT_WORD
export const GET_INVOICE_POS_REPORT_WORD = "GET_INVOICE_POS_REPORT_WORD";
export const GET_INVOICE_POS_REPORT_WORD_SUCCESS =
  "GET_INVOICE_POS_REPORT_WORD_SUCCESS";
export const GET_INVOICE_POS_REPORT_WORD_FAIL =
  "GET_INVOICE_POS_REPORT_WORD_FAIL";
export const RESET_GET_INVOICE_POS_REPORT_WORD =
  "RESET_GET_INVOICE_POS_REPORT_WORD";

// ACTION_WORKFLOW_INVOICE_POS
// SUBMIT/APPROVE/REJECT
export const ACTION_WORKFLOW_INVOICE_POS = "ACTION_WORKFLOW_INVOICE_POS";
export const ACTION_WORKFLOW_INVOICE_POS_SUCCESS =
  "ACTION_WORKFLOW_INVOICE_POS_SUCCESS";
export const ACTION_WORKFLOW_INVOICE_POS_FAIL =
  "ACTION_WORKFLOW_INVOICE_POS_FAIL";
export const RESET_ACTION_WORKFLOW_INVOICE_POS =
  "RESET_ACTION_WORKFLOW_INVOICE_POS";

// Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
export const CREATE_INVOICE_POS_ENTERPRISE = "CREATE_INVOICE_POS_ENTERPRISE";
export const CREATE_INVOICE_POS_ENTERPRISE_SUCCESS =
  "CREATE_INVOICE_POS_ENTERPRISE_SUCCESS";
export const CREATE_INVOICE_POS_ENTERPRISE_FAIL =
  "CREATE_INVOICE_POS_ENTERPRISE_FAIL";
export const RESET_CREATE_INVOICE_POS_ENTERPRISE =
  "RESET_CREATE_INVOICE_POS_ENTERPRISE";

// Tạo hóa đơn điều chỉnh giảm 100%
export const CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL =
  "CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL";
export const CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS =
  "CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS";
export const CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL =
  "CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL";
export const RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL =
  "RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL";

// UPLOAD_FILE_INVOICE
export const UPLOAD_FILE_INVOICE_POS = "UPLOAD_FILE_INVOICE_POS";
export const UPLOAD_FILE_INVOICE_POS_SUCCESS =
  "UPLOAD_FILE_INVOICE_POS_SUCCESS";
export const UPLOAD_FILE_INVOICE_POS_FAIL = "UPLOAD_FILE_INVOICE_POS_FAIL";
export const UPLOAD_FILE_INVOICE_POS_RESET = "UPLOAD_FILE_INVOICE_POS_RESET";

// REMOVE_FILE_INVOICE
export const REMOVE_FILE_INVOICE_POS = "REMOVE_FILE_INVOICE_POS";
export const REMOVE_FILE_INVOICE_POS_SUCCESS =
  "REMOVE_FILE_INVOICE_POS_SUCCESS";
export const REMOVE_FILE_INVOICE_POS_FAIL = "REMOVE_FILE_INVOICE_POS_FAIL";
export const REMOVE_FILE_INVOICE_POS_RESET = "REMOVE_FILE_INVOICE_POS_RESET";

// EXPORT_INVOICE
export const EXPORT_INVOICE_POS = "EXPORT_INVOICE_POS";
export const EXPORT_INVOICE_POS_SUCCESS = "EXPORT_INVOICE_POS_SUCCESS";
export const EXPORT_INVOICE_POS_FAIL = "EXPORT_INVOICE_POS_FAIL";
export const EXPORT_INVOICE_POS_RESET = "EXPORT_INVOICE_POS_RESET";

// EXPORT_INVOICE_TICKET
export const EXPORT_INVOICE_POS_TICKET = "EXPORT_INVOICE_POS_TICKET";
export const EXPORT_INVOICE_POS_TICKET_SUCCESS =
  "EXPORT_INVOICE_POS_TICKET_SUCCESS";
export const EXPORT_INVOICE_POS_TICKET_FAIL = "EXPORT_INVOICE_POS_TICKET_FAIL";
export const EXPORT_INVOICE_POS_TICKET_RESET =
  "EXPORT_INVOICE_POS_TICKET_RESET";

// EXPORT_INVOICE_WAREHOUSES
export const EXPORT_INVOICE_POS_WAREHOUSES = "EXPORT_INVOICE_POS_WAREHOUSES";
export const EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS =
  "EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS";
export const EXPORT_INVOICE_POS_WAREHOUSES_FAIL =
  "EXPORT_INVOICE_POS_WAREHOUSES_FAIL";
export const EXPORT_INVOICE_POS_WAREHOUSES_RESET =
  "EXPORT_INVOICE_POS_WAREHOUSES_RESET";

// EXPORT_INVOICE_WAREHOUSES_AGENCY
export const EXPORT_INVOICE_POS_WAREHOUSES_AGENCY =
  "EXPORT_INVOICE_POS_WAREHOUSES_AGENCY";
export const EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS =
  "EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS";
export const EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL =
  "EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL";
export const EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET =
  "EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET";

// INVOICE_CAMPAIGN_LIST
export const INVOICE_POS_CAMPAIGN_LIST = "INVOICE_POS_CAMPAIGN_LIST";
export const INVOICE_POS_CAMPAIGN_LIST_SUCCESS =
  "INVOICE_POS_CAMPAIGN_LIST_SUCCESS";
export const INVOICE_POS_CAMPAIGN_LIST_FAIL = "INVOICE_POS_CAMPAIGN_LIST_FAIL";
export const INVOICE_POS_CAMPAIGN_LIST_RESET =
  "INVOICE_POS_CAMPAIGN_LIST_RESET";
export const SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST =
  "SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST";

// UPLOAD_CAMPAIGNS_INVOICE
export const UPLOAD_CAMPAIGNS_INVOICE_POS = "UPLOAD_CAMPAIGNS_INVOICE_POS";
export const UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS =
  "UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS";
export const UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL =
  "UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL";
export const UPLOAD_CAMPAIGNS_INVOICE_POS_RESET =
  "UPLOAD_CAMPAIGNS_INVOICE_POS_RESET";

// RELEASE_CAMPAIGNS_INVOICE
export const RELEASE_CAMPAIGNS_INVOICE_POS = "RELEASE_CAMPAIGNS_INVOICE_POS";
export const RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS =
  "RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS";
export const RELEASE_CAMPAIGNS_INVOICE_POS_FAIL =
  "RELEASE_CAMPAIGNS_INVOICE_POS_FAIL";
export const RELEASE_CAMPAIGNS_INVOICE_POS_RESET =
  "RELEASE_CAMPAIGNS_INVOICE_POS_RESET";

// INVOICE_CAMPAIGN_DETAIL
export const INVOICE_POS_CAMPAIGN_DETAIL = "INVOICE_POS_CAMPAIGN_DETAIL";
export const INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS =
  "INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS";
export const INVOICE_POS_CAMPAIGN_DETAIL_FAIL =
  "INVOICE_POS_CAMPAIGN_DETAIL_FAIL";
export const INVOICE_POS_CAMPAIGN_DETAIL_RESET =
  "INVOICE_POS_CAMPAIGN_DETAIL_RESET";

// GET_DATA_LINK_POS
export const GET_DATA_LINK_POS = "GET_DATA_LINK_POS";
export const GET_DATA_LINK_POS_SUCCESS = "GET_DATA_LINK_POS_SUCCESS";
export const GET_DATA_LINK_POS_FAIL = "GET_DATA_LINK_POS_FAIL";
export const GET_DATA_LINK_POS_RESET = "GET_DATA_LINK_POS_RESET";

// GET_INVOICE_POS_MAX_DATE
export const GET_INVOICE_POS_MAX_DATE = "GET_INVOICE_POS_MAX_DATE";
export const GET_INVOICE_POS_MAX_DATE_SUCCESS =
  "GET_INVOICE_POS_MAX_DATE_SUCCESS";
export const GET_INVOICE_POS_MAX_DATE_FAIL = "GET_INVOICE_POS_MAX_DATE_FAIL";
export const GET_INVOICE_POS_MAX_DATE_RESET = "GET_INVOICE_POS_MAX_DATE_RESET";

// GET_INVOICE_POS_MIN_DATE
export const GET_INVOICE_POS_MIN_DATE = "GET_INVOICE_POS_MIN_DATE";
export const GET_INVOICE_POS_MIN_DATE_SUCCESS =
  "GET_INVOICE_POS_MIN_DATE_SUCCESS";
export const GET_INVOICE_POS_MIN_DATE_FAIL = "GET_INVOICE_POS_MIN_DATE_FAIL";
export const GET_INVOICE_POS_MIN_DATE_RESET = "GET_INVOICE_POS_MIN_DATE_RESET";

// DOWNLOAD_ZIP_INVOICE
export const DOWNLOAD_ZIP_INVOICE_POS = "DOWNLOAD_ZIP_INVOICE_POS";
export const DOWNLOAD_ZIP_INVOICE_POS_SUCCESS =
  "DOWNLOAD_ZIP_INVOICE_POS_SUCCESS";
export const DOWNLOAD_ZIP_INVOICE_POS_FAIL = "DOWNLOAD_ZIP_INVOICE_POS_FAIL";
export const RESET_DOWNLOAD_ZIP_INVOICE_POS = "RESET_DOWNLOAD_ZIP_INVOICE_POS";

export const BK_DATA_NEW_POS = "BK_DATA_NEW_POS";
export const RESET_BK_DATA_NEW_POS = "RESET_BK_DATA_NEW_POS";

// GET_CURRENT_TIME_POS
export const GET_CURRENT_TIME_POS = "GET_CURRENT_TIME_POS";
export const GET_CURRENT_TIME_POS_SUCCESS = "GET_CURRENT_TIME_POS_SUCCESS";
export const GET_CURRENT_TIME_POS_FAIL = "GET_CURRENT_TIME_POS_FAIL";
